import { Injectable } from "@angular/core";

@Injectable()
export class CartService {

  carrinho: any[] = [];
  produtos = [];

  constructor() {
    this.produtos;
  }


  atualizarCarrinho(item: any) {
    this.carrinho = JSON.parse(localStorage.getItem("carrinho"));
    if (this.carrinho == null) {
      this.carrinho = [];
    }

    let itemCart = item;
    itemCart.vlrTotalItem = Number(item.preco) * item.quantidade;
    let indiceProduto = this.getIndiceProduto(item);

    if (indiceProduto >= 0) {
      if (itemCart.quantidade == 0) {
        this.carrinho.splice(indiceProduto, 1);
      } else {
        this.carrinho[indiceProduto].quantidade = itemCart.quantidade;
        this.carrinho[indiceProduto].vlrTotalItem = itemCart.vlrTotalItem;
      }
    } else {
      this.carrinho.push(itemCart);
    }
    localStorage.setItem("carrinho", JSON.stringify(this.carrinho));
    this.calculaQtdePedido();
    this.calculaValorTotalPedido();
  }

  apagarProduto(item: any) {
    this.carrinho = JSON.parse(localStorage.getItem("carrinho"));
    if (this.carrinho == null) {
      this.carrinho = [];
    }
    let indiceProduto = this.getIndiceProduto(item);

    if (indiceProduto >= 0) {
      this.carrinho.splice(indiceProduto, 1);
      localStorage.setItem("carrinho", JSON.stringify(this.carrinho));
      this.calculaQtdePedido();
      this.calculaValorTotalPedido();
    }
  }

  getIndiceProduto(item) {
    let indice: number = -1;
    if (this.carrinho) {
      for (let i = 0; i < this.carrinho.length; i++) {
        if (this.carrinho[i].codigo == item.codigo) {
          indice = i;
        }
      }
    }
    return indice;
  }


  limparCarrinho() {
    localStorage.setItem("carrinho", JSON.stringify(null));
    this.carrinho = [];
  }

  calculaValorTotalPedido() {
    let valorTotalPedido: Number = 0;
    if (this.carrinho) {
      for (let i = 0; i < this.carrinho.length; i++) {
        valorTotalPedido = valorTotalPedido + this.carrinho[i].vlrTotalItem
      }
    }
    return valorTotalPedido.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  }

  calculaQtdePedido() {
    return this.carrinho ? this.carrinho.length : 0
  }

  filterItems(searchTerm) {
    return this.produtos.filter((item) => {
      return item.nome.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/cart.service.ts